 <template>
    <v-dialog v-model="stop_project_dialog" v-on:click:outside="close_dialog" @keydown.esc="close_dialog" max-width="600px">
      <v-form width="250" ref="stop_project_form" lazy-validation>
        <v-card>
          <v-alert v-if="stop_project_error" class="error my-0 pa-2" tile>
            <v-icon small class="pb-1">warning</v-icon>
            <span class="subtitle-1 font-weight-medium pl-2">{{stop_project_error}}</span>
          </v-alert>
          <v-btn class="float-right" fab dark small text @click="close_dialog">
            <v-icon dark>mdi-close</v-icon>
          </v-btn>
          <v-card-title class="pa-2">
            <span class="subtitle-1 font-weight-medium grey darken-3 px-2">Are you sure you want to stop all jobs under the submission?</span>
          </v-card-title>
          <v-card-text>
            <v-container class="pa-0">
              <v-row>
                <v-col class="py-0" cols="12">
                  <v-autocomplete
                    v-model="stop_select"
                    :items="['No longer needed', `Results aren't as expected`, 'Taking too long', 'Costing too much', 'Enter reason text']"
                    label="Reason"
                    :rules="stopSelectRules"
                  ></v-autocomplete>
                </v-col>
                <v-col v-if="stop_select == `Enter reason text`" class="py-0" cols="12">
                  <v-text-field class="py-0" label="Reason*" v-model="stop_reason" :rules="stopReasonRules" required></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="12">
                  <small class="ml-4">*Required</small>
                </v-col>
              </v-row>
            </v-container>
            
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn x-small depressed color="error" @click="stop_project('stop')">Stop</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
</template> 
<script>
  import axios from 'axios';

  export default {
    name: "StopJobDialog",
    props: {
      stop_project_dialog: {
        type: Boolean
      },
      stop_project_obj: {
        type: Object
      },
      close_stop_project_dialog: {
        type: Function
      },
      refresh_parent: {
        type: Function
      }
    },
    data() {
      return {
        stop_project_error: null,
        stop_select: '',
        stopSelectRules: [
          v => v.length > 0 || 'Please select a reason',
        ],
        stop_reason: '',
        stopReasonRules: [
          v => this.stop_select == 'Enter reason text' && (!!v || 'Please enter a reason'),
          v => this.stop_select == 'Enter reason text' && (v.length >= 3 || 'Minimum length is 3 characters'),
        ],
      }
    },
    methods:{
      close_dialog(){
        this.stop_project_error=null;
        this.close_stop_project_dialog();
      },
      stop_project(action){
        if(this.$refs.stop_project_form.validate()) {
          this.post_stop_project(action);
        }
      },
      post_stop_project(action){
        var project_id = this.stop_project_obj.id;
        var project_stop_reason = (this.stop_select != "Enter reason text") ? this.stop_select : this.stop_reason;
        var project_stop_params = {
          "params" : {
            "reason" : project_stop_reason
          }
        }

        axios.post(`https://${this.$buyerAPI}/projects/${project_id}?action=${action}`, project_stop_params)
        .then(() => {
          this.close_dialog();
          this.refresh_parent();
        })
        .catch(error => {
          var resp = error.response && error.response.data;
          if (resp && resp.error){
            this.stop_project_error = resp.error;
          }else{
            this.stop_project_error = error.message
          }
        })  
      },
    }
  }
</script>

<style>
.v-input__slot{
  margin-bottom: 0px !important;
}
.task_selection .v-messages{
  display: none;
}
</style>